var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 13.399l1.044-3.695 2.831-.009c.145 0 .263-.047.355-.142s.131-.207.118-.337c-.092-.769-.384-1.47-.877-2.104s-1.107-1.115-1.843-1.447l-.444-3.417c.407-.343.67-.757.789-1.243a.368.368 0 00-.108-.346A.453.453 0 009.159.5H4.841a.49.49 0 00-.365.151.363.363 0 00-.089.346 2.26 2.26 0 00.779 1.251l-.444 3.417A4.84 4.84 0 002.87 7.121a4.275 4.275 0 00-.867 2.112c-.013.13.026.243.118.337s.21.142.355.142l2.834-.009 1.045 3.695c.055.225.25.601.646.601s.593-.367.65-.601z"
  })));
}

export default SvgPin;